import { Party } from '../models';

/**
 * Whether a party has been seated/served (its `seated_time` is set).
 * Business-hours / availability validation is meaningless for a seated party,
 * since it was necessarily seated in the past.
 */
export function isPartySeated(party: Pick<Party, 'seated_time'> | null | undefined): boolean {
  return party?.seated_time != null;
}
